import { motion } from "framer-motion";

// A wafer-thin section label used across the site: "01 / Selected Work"
export default function SectionLabel({ number, children, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
      className={`flex items-center gap-3 font-sans text-[11px] uppercase tracking-widest text-ivory-muted ${className}`}
    >
      <span className="h-px w-8 bg-gold" />
      {number ? <span className="text-gold font-medium">{number}</span> : null}
      <span>{children}</span>
    </motion.div>
  );
}
